// types
import { type ModuleType as Permission } from "./_definitions"
import { type State } from "../../types"

export const permissionSelector = (state: State): Permission => state.permission
